import { render, staticRenderFns } from "./InPerson.vue?vue&type=template&id=5bb20499"
import script from "./InPerson.vue?vue&type=script&lang=js"
export * from "./InPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports